import classnames from "classnames";
import { ModalDeleteIcon } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import styles from "./DeleteConfirmModal.module.scss";

const DeleteConfirmModal = ({
  isOpen,
  entry,
  onConfirm,
  onClose,
  loading
}) => {
  if (!entry) return null;

  const getDisplayName = () => {
    if (entry.blacklist_type === 'contact') {
      return `${entry.contact_name || 'Unknown'} (${entry.contact_email || 'no email'})`;
    } else if (entry.blacklist_type === 'domain') {
      return entry.domain || 'Unknown domain';
    }
    return entry.blacklist_display_name || 'Unknown';
  };

  const getTypeDisplay = () => {
    if (entry.blacklist_type === 'contact') {
      return 'contact';
    } else if (entry.blacklist_type === 'domain') {
      return 'domain';
    }
    return 'entry';
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    if (onConfirm && !loading) {
      onConfirm();
    }
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>Remove from Blacklist</h2>
      <p className={styles.description}>
        Do you want to remove {getDisplayName()} from the blacklist? This process cannot be undone.
      </p>
      <div className={styles.group}>
        <Button size={VIEW.MIDDLE} color={COLOR.NONE} onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleConfirm} disabled={loading}>
          {loading ? "Removing..." : "Remove"}
        </Button>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;